module.exports = __webpack_public_path__ + "resources/img/bg_cover_support_m_v2.9f0773e5af4fdb4f4fde688dad89f812.png";